module.exports = __webpack_public_path__ + "img/buy-chuti.f80d0350.jpg";